<template>
  <div class="header bg-primary">
    <svg
      width="430"
      height="581"
      viewBox="0 0 430 581"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="
        width: 150px !important;
        height: 150px !important;
        position: absolute;
        right: 1% !important;
        top: 10% !important;
      "
    >
      <g opacity="0.6" filter="url(#filter0_f_315_9262)">
        <path
          d="M-29.0358 570.445C-23.9775 546.713 -7.43126 525.338 8.5327 506.266C21.7677 490.455 34.772 474.542 47.3152 458.318C71.8003 482.418 103.494 499.502 138.55 507.236C183.17 517.072 228.434 508.506 272.521 497.863C313.231 488.038 357.15 478.33 387.46 448.697C399.822 436.609 409.109 421.913 412.597 405.585C417.144 384.278 410.158 363.173 417.354 341.971C418.526 338.52 419.778 335.133 421.062 331.768L413.971 284.231C411.137 265.241 383.767 261.52 373.997 278.742C373.88 278.946 373.77 279.139 373.653 279.344C359.327 304.283 331.133 313.966 310.12 332.765C288.806 351.82 276.127 377.605 253.173 395.215C229.887 413.069 200.684 422.764 171.775 428.676C146.486 433.843 120.799 436.51 95.2733 440.216C154.134 406.084 211.802 369.693 259.889 322.69C285.907 297.258 308.671 269.038 326.098 237.956C345.415 203.505 356.001 165.964 363.877 128.252C368.218 107.454 371.1 85.4184 362.539 65.4971C354.946 47.8269 337.967 33.8413 336.083 14.0905C335.386 6.77149 324.41 6.53654 321.424 12.7254C292.523 72.5034 241.361 120.607 212.95 180.642C197.446 213.396 193.07 249.016 179.21 282.222C166.591 312.466 147.221 339.808 125.039 364.878C112.45 379.107 98.9742 392.592 85.0516 405.686C101.02 381.613 115.872 356.916 129.51 331.687C145.727 301.684 160.239 270.729 168.483 238.103C178.316 199.177 176.143 159.548 171.032 120.552C166.752 87.9153 165.206 48.818 137.314 25.6372C134.237 23.0768 128.948 24.4451 126.585 27.2839C91.6337 69.3513 94.3605 124.022 88.5507 173.553C84.9884 203.909 76.1682 234.222 81.6628 264.643C84.4454 280.021 86.751 293.732 82.4127 309.309C78.4824 323.424 71.5927 336.788 65.8669 350.354C52.8241 381.282 43.6257 413.484 38.1969 446.127C26.3088 461.769 13.9518 477.112 1.19207 492.2C-19.0964 516.193 -40.303 542.02 -44.9594 572.875L-44.956 572.893L-29.0545 570.449L-29.0358 570.445Z"
          fill="#01452E"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_315_9262"
          x="-52.9594"
          y="0.324707"
          width="482.022"
          height="580.569"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4"
            result="effect1_foregroundBlur_315_9262"
          />
        </filter>
      </defs>
    </svg>

    <b-container fluid>
      <div class="header-body">
        <slot></slot>
      </div>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "base-header",
  props: {
    type: {
      type: String,
      default: "success",
      description: "Header background type",
    },
  },
};
</script>
<style></style>
